import Profile from '@/services/profile'
import localforage from 'localforage'

const fetch = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Profile.permissions().then(async (response) => {
      await localforage.setItem('current_permissions', response.data)
      commit('SET_LIST', response.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

export default {
  fetch
}



// WEBPACK FOOTER //
// ./src/features/permissions/store/actions.js